import type { ExtrasCategoryToFilterType } from "../../../../../common-deprecated/types/CommonTypes";

export const EXTRASFILTER_SET_SEARCHSTRING = "extrasFilter/setSearchString" as const;
export const EXTRASFILTER_SET_TEMP_ROOT_CATEGORY_TO_FILTER = "extrasFilter/setTempRootCategoryToFilter" as const;
export const EXTRASFILTER_SET_AVAILABLE_ONLINE_TO_FILTER = "extrasFilter/setAvailableOnlineToFilter" as const;
export const EXTRASFILTER_SET_TEMP_CATEGORIES_TO_FILTER = "extrasFilter/setTempCategoriesToFilter" as const;
export const EXTRASFILTER_APPLY_EXTRAS_FILTER = "extrasFilter/applyExtrasFilter" as const;
export const EXTRASFILTER_TOGGLE_EXTRAS_FILTER = "extrasFilter/toggleExtrasFilter" as const;
type SetSearchStringType = {
    type: typeof EXTRASFILTER_SET_SEARCHSTRING;
    searchString: string;
};
type SetTempRootCategoryToFilterType = {
    type: typeof EXTRASFILTER_SET_TEMP_ROOT_CATEGORY_TO_FILTER;
    tempRootCategoryToFilter: ExtrasCategoryToFilterType | null;
};
type SetAvailableOnlineToFilterType = {
    type: typeof EXTRASFILTER_SET_AVAILABLE_ONLINE_TO_FILTER;
    availableOnlineToFilter: boolean;
};
type SetTempCategoriesToFilterType = {
    type: typeof EXTRASFILTER_SET_TEMP_CATEGORIES_TO_FILTER;
    tempCategoriesToFilter: ExtrasCategoryToFilterType[];
};
type ApplyExtrasFilterType = {
    type: typeof EXTRASFILTER_APPLY_EXTRAS_FILTER;
};
type ToggleExtrasFilterType = {
    type: typeof EXTRASFILTER_TOGGLE_EXTRAS_FILTER;
};
export const setSearchString = (searchString: string): SetSearchStringType => ({
    type: EXTRASFILTER_SET_SEARCHSTRING,
    searchString,
});
export const setTempRootCategoryToFilter = (
    tempRootCategoryToFilter: ExtrasCategoryToFilterType | null,
): SetTempRootCategoryToFilterType => ({
    type: EXTRASFILTER_SET_TEMP_ROOT_CATEGORY_TO_FILTER,
    tempRootCategoryToFilter,
});
export const setAvailableOnlineToFilter = (availableOnlineToFilter: boolean): SetAvailableOnlineToFilterType => ({
    type: EXTRASFILTER_SET_AVAILABLE_ONLINE_TO_FILTER,
    availableOnlineToFilter,
});
export const setTempCategoriesToFilter = (
    tempCategoriesToFilter: ExtrasCategoryToFilterType[],
): SetTempCategoriesToFilterType => ({
    type: EXTRASFILTER_SET_TEMP_CATEGORIES_TO_FILTER,
    tempCategoriesToFilter,
});
export const applyExtrasFilter = (): ApplyExtrasFilterType => ({
    type: EXTRASFILTER_APPLY_EXTRAS_FILTER,
});
export const toggleExtrasFilter = (): ToggleExtrasFilterType => ({
    type: EXTRASFILTER_TOGGLE_EXTRAS_FILTER,
});
export type ExtrasFilterActionsType =
    | SetSearchStringType
    | SetTempRootCategoryToFilterType
    | SetAvailableOnlineToFilterType
    | SetTempCategoriesToFilterType
    | ApplyExtrasFilterType
    | ToggleExtrasFilterType;
